export default "__VITE_ASSET__iV1_ZGEV__"